import { render, staticRenderFns } from "./qalist.vue?vue&type=template&id=4d5b1636&scoped=true"
import script from "./qalist.vue?vue&type=script&lang=js"
export * from "./qalist.vue?vue&type=script&lang=js"
import style0 from "./qalist.vue?vue&type=style&index=0&id=4d5b1636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5b1636",
  null
  
)

export default component.exports